<template>
  <article class="relative">
    <div @click="clearPost('blog')" class="flex mt-22.5 mb-7.5 ml-4.5">
      <svg class="mr-5 transform rotate-90 w-3" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 6L7 12L13 6" stroke="#323749" stroke-linejoin="round"/>
        <path d="M6.99998 0V12" stroke="#323749" stroke-linejoin="round"/>
      </svg>
      <p class="uppercase font-medium fz-10" style="letter-spacing: 0.1rem; color:rgba(110, 117, 141, 1) ">{{ text.blog }}</p>
    </div>
    <div class="post-header flex flex-col mx-4.5">
        <h1 style="color: #f22959; line-height: 1.33;" class="font-light mb-5 fz-30">{{post.title}}</h1>
        <img src="@/assets/images/share.svg" class="w-12" alt="" />
    </div>
    <p class="mt-5 mb-7.5 fz-16 mx-4.5" style="line-height:1.875">{{post.headerText}}</p>

    <div class="post-info flex justify-between items-center mx-4.5 mb-22.5">
        <span class="text-gray font-medium fz-10" style="letter-spacing: 0.1rem;">{{post.date}}</span>
        <div class="tags flex gap-x-2.5">
            <p
                    v-for="item in post.tags"
                    :key="item"
                    class="py-1.25 px-3.75 rounded-full border fz-13" style="line-height:1.5384; border-color:rgba(151, 163, 203, 0.3)">
                        {{tags[item]}}
                    </p>
        </div>
    </div>

    <div v-for="contentPart in Object.entries(post.content)" :key="contentPart[0]">
      <imageElement v-if="contentPart[0].includes('imageElement')" :source="postId + '/' + contentPart[1].source"/>
      <slider
          v-if="contentPart[0].includes('doubleSlider')"
          :slides-container-classes="'pl-4.5 mb-7.75 gap-5'"
          :slider-classes="'mb-25'"
          :similar-slides="true"
          :pagination="true"
          pagination-container-classes="gap-5 pl-4.5"
      >
        <template v-slot:slides>
          <div
              class="slider-slide w-80 flex flex-col"
              v-for="item in contentPart[1].sources"
              :key="item"
          >
            <img
                :src="
              require('@/assets/images/blog/' + this.postId + '/slider/' + item)
            "
                class="w-80 h-80"
                style="background: rgba(110, 117, 141, 0.2)"
                alt=""
            />
          </div>
        </template>
        <template v-slot:pagination>
          <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
        </template>
      </slider>
      <postSection v-else-if="contentPart[0].includes('postSection')" :content="contentPart[1]"/>
      <imageWithMark v-else-if="contentPart[0].includes('imageWithMark')" :source="postId + '/' + contentPart[1].source" :marks="contentPart[1].marks"/>
    </div>


    <a href="#mobile-start" class="to-top flex flex-col my-25 ml-19.5">
      <svg class="transform rotate-180 mb-2.5 w-3" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 6L7 12L13 6" stroke="rgba(151, 163, 203, 0.6)" stroke-linejoin="round"/>
        <path d="M6.99998 0V12" stroke="rgba(151, 163, 203, 0.6)" stroke-linejoin="round"/>
      </svg>
      <p class="uppercase font-medium fz-10" style="line-height: 1; color: rgba(151, 163, 203, 0.6); letter-spacing: 0.3rem">{{ text.back }}</p>
    </a>

<!--    <div class="next relative flex flex-col pt-10">-->
<!--      <img class="absolute top-0 h-full min-w-screen" style="z-index: -1;" :src="require('@/assets/images/blog/' + postId + '/next.png')" alt="">-->
<!--      <p class="uppercase fz-13 mb-2.5 font-semibold ml-4.5" style="line-height: 1.5384;">{{text.next}}</p>-->
<!--      <h3 class="fz-22 ml-4.5 mb-9.5" style="line-height: 1.3636;">{{post.nextTitle}}</h3>-->
<!--      <div class="h-2" style="background:#f22959;"></div>-->
<!--    </div>-->
  </article>
</template>

<script>
import slider from "@/components/mobile/reuseable/slider";
import imageElement from "@/components/mobile/pages/postElements/imageElement";
import imageWithMark from "@/components/mobile/pages/postElements/imageWithMark";
import textElement from "@/components/mobile/pages/postElements/textElement";
import postSection from "@/components/mobile/pages/postElements/postSection";
import miniMarkedList from "@/components/mobile/pages/postElements/miniMarkedList";
import numberedList from "@/components/mobile/pages/postElements/numberedList";
import markedList from "@/components/mobile/pages/postElements/markedList";

import {mapMutations, mapState} from "vuex";


export default {
  name: "project",
  components:{
    slider,
    imageElement,
    imageWithMark,
    textElement,
    postSection,
    miniMarkedList,
    numberedList,
    markedList
  },
  computed:{
    ...mapState(['lang', 'postId']),
    text(){
      return {
        ...require("@/assets/text/blog/posts/" + this.lang + ".json")
      };
    },
    tags(){
      return require("@/assets/text/blog/posts/" + this.lang + ".json").tags;
    },
    post(){
        return this.text.posts[this.postId]
    }
  },
  methods:{
    ...mapMutations(['clearPost'])
  }
}
</script>

<style scoped>
#app{
  height: auto!important;
}
</style>
